import { AbstractControl } from '@angular/forms';
import moment from 'moment';

export const range = (start: number, end: number) => {
  const arr = [];
  for (let i = start; i <= end; i++) {
    arr.push(i);
  }
  return arr;
};



export function getRandomInt(min: number, max: number){
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function isNumeric(str): boolean {
  return (new RegExp('^[0-9]{1}$')).test(str);
}

export function isAlpha(str: string): boolean {
  const enRange = isUpperEnAlpha(str); // upper alpha (A-Z)
  const heRange = isHebAlpha(str); // upper alpha (A-Z)
  const enRangeLower = isLowerAlpha(str); // upper alpha (A-Z)
  return enRange || enRangeLower || heRange;
}

export function isHebAlpha(str: string): boolean {
  return (new RegExp('^[א-ת]{1}$')).test(str);
}

export function isUpperEnAlpha(str: string): boolean {
  return (new RegExp('^[A-Z]{1}$')).test(str);
}

export function isLowerAlpha(str: string): boolean {
  return (new RegExp('^[a-z]{1}$')).test(str);
}

export function isIncludeHebAlpha(str: string): boolean {
  return (new RegExp('[א-ת]')).test(str);
}

export function isNumeric2Digits(str: string) {
  return (new RegExp('^\\d[0-9]{1}$')).test(str);
}

export function isNumericLimitDigits(str, limit: number): boolean {
  return (new RegExp(`^[0-9]{0,${limit}}$`)).test(str);
}

export function isAlphaNumeric(str: string) {
  return (new RegExp('^[A-Za-zא-ת]{1}\\d[0-9]{0,2}$')).test(str);
}
export function isNumericAlpha(str: string) {
  return (new RegExp('^\\d[0-9]{0,2}[A-Za-zא-ת]{1}$')).test(str);
}

export function isAlphaDouble(str: string) {
  return (new RegExp('^[A-Za-zא-ת]{2}$')).test(str);
}

export function getLightRandomColor() {
  const letters = 'BCDEF'.split('');
  let color = '';
  for (let i = 0; i < 6; i++ ) {
    color += letters[Math.floor(Math.random() * letters.length)];
  }
  return color;
}

export function getNextDayOfWeek(date, dayOfWeek) {
  const resultDate = moment(date.getTime()).toDate();
  resultDate.setDate(date.getDate() + (7 + dayOfWeek - date.getDay()) % 7);
  return resultDate;
}

export function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function validateCCEmail(control: AbstractControl): { [key: string]: boolean } | null {
  let value = control?.value?.replace(/\s/g, '');
  if(!value) {
    return ;
  }
  if (value.charAt(value.length - 1) === ';') {
    value = value.substring(0, value.length - 1);
  }
  value = value.split(';');
  const valueNotValidate = value?.filter(v => !validateEmail(v)).length;
  if (valueNotValidate) {
    return {ccEmail: false};
  }
  return null;
}

/**
 * @param color : String|Array|Object
 * Color in HEX string, RGB array or RGB object to be inverted.
 * @param bw : Boolean|Object
 * Optional. A boolean value indicating whether the output should be amplified to black (#000000) or white (#ffffff),
 * according to the luminance of the original color. You can set custom black/white values (and/or luminance threshold) by passing an object.
 */
export function invertColor(hex, bw): string {
  if (hex.indexOf('#') === 0) {
    hex = hex.slice(1);
  }
  // convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    throw new Error('Invalid HEX color.');
  }
  let r: number | string = parseInt(hex.slice(0, 2), 16);
  let g: number | string = parseInt(hex.slice(2, 4), 16);
  let b: number | string = parseInt(hex.slice(4, 6), 16);
  if (bw) {
    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
      ? '#000000'
      : '#FFFFFF';
  }
  // invert color components
  r = (255 - r).toString(16);
  g = (255 - g).toString(16);
  b = (255 - b).toString(16);
  // pad each with zeros and return
  return '#' + this.padZero(r) + this.padZero(g) + this.padZero(b);
}

export function padZero(str, len = 2): string {
  const zeros = new Array(len).join('0');
  return (zeros + str).slice(-len);
}

export function parseLocalDate(dateStr: string): Date {
  if (!dateStr) {
    return;
  }
  
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
}